module.exports = __webpack_public_path__ + "static/media/noResults.4b427eee.png";